export default "__VITE_ASSET__BeW79UzU__";